import {
  ASSIGN_TICKET_FAILURE,
  ASSIGN_TICKET_SUCCESS,
  CREATE_TICKETS_FAILURE,
  CREATE_TICKETS_SUCCESS,
  FETCH_TICKETS_FAILURE,
  FETCH_TICKETS_SUCCESS,
  FETCH_TICKET_BY_ID_FAILURE,
  FETCH_TICKET_BY_ID_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_SUCCESS,
  UPDATE_TICKETS_FAILURE,
  UPDATE_TICKETS_SUCCESS,
  UPDATE_TICKET_STATUS_FAILURE,
  UPDATE_TICKET_STATUS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  tickets: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },
  selectedTicket: null,
  error: null,
  users: [],
};

export default function ticketReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case CREATE_TICKETS_SUCCESS:
    case UPDATE_TICKET_STATUS_SUCCESS:
    case UPDATE_TICKETS_SUCCESS:
    case ASSIGN_TICKET_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: action.payload.tickets,
        pagination: action.payload.pagination,
        error: null,
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.users,
        error: null,
      };
    case FETCH_TICKET_BY_ID_SUCCESS:
      return {
        ...state,
        selectedTicket: action.payload,
        error: null,
      };
    case FETCH_TICKETS_FAILURE:
    case FETCH_TICKET_BY_ID_FAILURE:
    case CREATE_TICKETS_FAILURE:
    case UPDATE_TICKETS_FAILURE:
    case ASSIGN_TICKET_FAILURE:
    case FETCH_USERS_FAILURE:
    case UPDATE_TICKET_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
